import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=2020e85a"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports